<template>
	<div
		:class="[
			space === 'xs' ? 'mt-8' : '',
			space === 'sm' ? 'mt-12 md:mt-16' : '',
			space === 'md' ? 'mt-20 md:mt-24' : '',
			space === 'lg' ? 'mt-24 md:mt-32' : '',
			space === 'xl' ? 'mt-32 md:mt-48' : '',
		]"
	/>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		space?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	}>(),
	{
		space: 'xs',
	}
);
</script>
